import { FC, useContext } from 'react';

import { Typography } from 'antd';

import { ColSize, ContentSection, RowSize } from '../../../../../../../../../shared/components';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { DataQuotation } from '../../interfaces';

import { formattedPrice } from '../../../../../../../../../shared/utils';

import './index.css';

interface SumTotalProps {
  dataQuotation?: DataQuotation;
}

export const SumTotal: FC<SumTotalProps> = ({ dataQuotation }) => {
  const { sumaAsegurada, premio } = dataQuotation || {};

  const { isPersonalDomestic } = useContext(StepThreeFormContext);

  return (
    <ContentSection level='h3' title='Sumas Totales'>
      <RowSize className='row-sum-total-quotation-life'>
        <ColSize size={25}>
          <RowSize>
            <ColSize size={100}>
              <Typography.Text
                type='secondary'
                className='label-sum-total-quotation-life'
              >
                Total suma asegurada
              </Typography.Text>
            </ColSize>
          </RowSize>
          <RowSize>
            <ColSize size={100}>
              <Typography.Text strong className='text-sum-total-quotation-life'>
                ${formattedPrice(String(sumaAsegurada))}
              </Typography.Text>
            </ColSize>
          </RowSize>
        </ColSize>

        {isPersonalDomestic && (
          <ColSize size={25}>
            <RowSize>
              <ColSize size={100}>
                <Typography.Text
                  type='secondary'
                  className='label-sum-total-quotation-life'
                >
                  Total Premio
                </Typography.Text>
              </ColSize>
            </RowSize>
            <RowSize>
              <ColSize size={100}>
                <Typography.Text className='text-sum-total-quotation-life'>
                  ${formattedPrice(String(premio))}
                </Typography.Text>
              </ColSize>
            </RowSize>
          </ColSize>
        )}
      </RowSize>
    </ContentSection>
  );
};
